// Shared English → Somali department/subdepartment name translations
export const ENGLISH_TO_SOMALI_DEPT = {
  // ── Main departments ──────────────────────────────────────────
  'Commanders': 'Taliyayaal',
  'Leaders (8 leaders)': 'Hogaamo (8 Hogaan)',
  'Parts': 'Qeybaha',
  'Part': 'Qeybaha',
  'Divisions': 'Qeybaha',
  'Division': 'Qeybaha',
  'Sectors': 'Qeybaha',
  'Sector': 'Qeybaha',
  'Qaybaha': 'Qeybaha',
  'Qeybaha Ciidanka': 'Qeybaha',
  'Hogaaminta (8 Hogaamiye)': 'Hogaamo (8 Hogaan)',
  'Leadership (8 leaders)': 'Hogaamo (8 Hogaan)',
  'Hogaamo': 'Hogaamo (8 Hogaan)',
  'Hogaaminta': 'Hogaamo (8 Hogaan)',
  'Colo Madax-bannaan': 'Colal Madax Banaan',
  'Colo Madax Banaan': 'Colal Madax Banaan',
  'Colal Madax-bannaan': 'Colal Madax Banaan',
  'Independent Units': 'Colal Madax Banaan',
  'Kooxda Dugsiyada 30 iyo Naafada': 'Kooxda Dugsiyadda 30 iyo Naafada',
  'Dugsiyada 30 iyo Naafada': 'Kooxda Dugsiyadda 30 iyo Naafada',
  'General Headquarters': 'Taliska Guud',
  'General Command': 'Taliska Guud',
  'Headquarters': 'Taliska Guud',
  'HQ': 'Taliska Guud',
  'Central Headquarters': 'Taliska Guud',
  'Main Headquarters': 'Taliska Guud',
  'Ururka Taliska': 'Ururka Taliska (Ilaalada, Dhamaan)',
  'Independent Wars': 'Colal Madax Banaan',
  'School Team30 and Disability': 'Kooxda Dugsiyadda 30 iyo Naafada',
  'Police Command': 'Taliska Booliska',
  'Independent Branches': 'Laamaha Madaxa Banaan',
  'Regional Divisions': 'Qeybaha Gobollada',
  'Prisons Command': 'Taliska Asluubta',
  'Autonomous Departments': 'Laamaha Madaxa Banaan',
  'Regional Prisons': 'Xabsiyada Gobollada',
  'Default Department': 'Waaxda Caadiga ah',
  // ── Military sub-departments ──────────────────────────────────
  'Commander': 'Taliye',
  '2nd Deputy Commander': 'Taliye Kuxigeen',
  'Chief of Staff': 'Abaanduul',
  'Military Command': 'Hogaanka Ciidanka',
  'Operations Command': 'Hogaanka Hawlgalinta',
  'Training Command': 'Hogaanka Tababarka',
  'Communications Command': 'Hogaanka Isgaarsiinta',
  'Transport and Engineering Command': 'Hogaanka Gaadiidka iyo Farsamada',
  'Logistics Command': 'Hogaanka Taakulada',
  'Medical Command': 'Hogaanka Caafimaadka',
  'Financial Administration Command': 'Hogaanka Maamulka Lacagta',
  'Headquarters Unit (Guards and General Services)': 'Ururka Taliska (Ilaalada, Dhamaan)',
  '60th Division': 'Qeybta 60aad',
  'Qeybta 60-aad': 'Qeybta 60aad',
  'Qaybta 60aad': 'Qeybta 60aad',
  'Qeybta 7-aad (Bari)': 'Qeybta 7aad Bari',
  'Qeybta 7aad (Bari)': 'Qeybta 7aad Bari',
  'Qeybta 9-aad (Sanaag)': 'Qeybta 9aad Sanaag',
  'Qeybta 9aad (Sanaag)': 'Qeybta 9aad Sanaag',
  'Qeybta 26-aad (Sool)': 'Qeybta 26aad Sool',
  'Qeybta 26aad (Sool)': 'Qeybta 26aad Sool',
  'Aaga Cayn (Cayn Sector)': 'Aaga Cayn',
  '7th Division (East)': 'Qeybta 7aad Bari',
  '9th Division (Sanaag)': 'Qeybta 9aad Sanaag',
  '26th Division (Sool)': 'Qeybta 26aad Sool',
  'Ayn Sector': 'Aaga Cayn',
  'Martyrs (Fallen Soldiers Unit)': 'Dhimashada',
  'Dufaan Battalion (Nugaal Base)': 'Guutada Dufaan (Nugaal Base)',
  'Commando Battalion (Nugaal Base)': 'Guutada Kumaandooska (Nugaal Base)',
  '48th Unit (Qardho)': 'Ururka 48aad (Qardho)',
  'First Command Detachment (Garowe)': 'Hurinta Kowaad ee Taliska (Garowe)',
  // ── Police sub-departments ────────────────────────────────────
  'Deputy Commander 1': 'Taliye Kuxigeen 1',
  'Deputy Commander 2': 'Taliye Kuxigeen 2',
  'Finance Department': 'Hogaanka Maaliyadda',
  'Logistics Department': 'Hogaanka Saadka',
  'Community Policing': 'Boolisaynta Bulshada',
  'Training Department': 'Hogaanka Tababarada',
  'Criminal Investigation Department': 'Hogaanka Baarista Dambiyada',
  'Tax Enforcement Department': 'Hogaanka Ilaalinta Cashuuraha',
  'Road Safety Department': 'Hogaanka Nabadgalyada Wadooyinka',
  'Operations Department': 'Hogaanka Hawlaha',
  'Immigration Department': 'Laanta Socotada',
  'Rescue Unit': 'Ururka Birmadka',
  'SPU Unit (Special Police Unit)': 'Ururka SPU',
  'Carmo Training Center': 'K.Tababarada Carmo',
  'Health Department': 'Waaxada Caafimaadka',
  'Transport Department': 'Waaxda Gaadiidka',
  'Documentation Office': 'Xafiiska Warqabka',
  'Public Relations Office (Spokesperson)': 'Xafiiska Afhayeenka',
  // ── Custodial sub-departments ─────────────────────────────────
  'First Deputy Commander': 'Taliye Kuxigeen 1aad',
  'Second Deputy Commander': 'Taliye Kuxigeen 2aad',
  'Medical Department': 'Hogaanka Caafimaadka',
  'Training and Planning Department': 'Hogaanka Tababarada iyo Qorsheynta',
  'Prison Inspection and Investigation Department': 'Hogaanka Baariska iyo Kormeerka Xabsiyada',
  'Political and Public Awareness Department': 'Hogaanka Siyaasada iyo Wacyigalinta',
  'Custodial Corps Academy': 'Kuliyada Ciidanka Asluubta',
  'Construction Department': 'Waaxda Dhismaha',
  'General Headquarters Detachment': 'Horinta Taliska Guud',
};

/**
 * Returns the Somali display name for a department/subdepartment.
 * If the name is already Somali (not in the map), returns it as-is.
 */
export const toSomaliDept = (name) => {
  if (!name) return '';
  return ENGLISH_TO_SOMALI_DEPT[name] || name;
};

export const SOMALI_TO_ENGLISH_DEPT = Object.fromEntries(
  Object.entries(ENGLISH_TO_SOMALI_DEPT).map(([eng, som]) => [som, eng])
);

/**
 * Returns the English name for a department/subdepartment.
 * If the name is already English (not in the reverse map), returns it as-is.
 */
export const toEnglishDept = (name) => {
  if (!name) return '';
  return SOMALI_TO_ENGLISH_DEPT[name] || name;
};

/**
 * Returns an array of all known synonym strings (lowercase) for a department or sub-department name,
 * including English and Somali variations.
 */
export const getAllDeptSynonyms = (name) => {
  if (!name) return [];
  const raw = String(name).trim();
  const lower = raw.toLowerCase();
  const somali = toSomaliDept(raw);
  const english = toEnglishDept(raw);
  const somaliLower = (somali || "").trim().toLowerCase();
  const englishLower = (english || "").trim().toLowerCase();

  const set = new Set([lower, somaliLower, englishLower].filter(Boolean));

  Object.entries(ENGLISH_TO_SOMALI_DEPT).forEach(([eng, som]) => {
    const sLower = som.toLowerCase();
    const eLower = eng.toLowerCase();
    if (sLower === somaliLower || sLower === lower || eLower === lower || eLower === englishLower) {
      set.add(eLower);
      set.add(sLower);
    }
  });

  return Array.from(set);
};
